import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './css/index.css';
import App from './App';
import UserStore from './store/UserStore';
import ProductStore from './store/ProductStore';
import './fonts/Montserrat/Montserrat-Medium.ttf';
import './fonts/Montserrat/Montserrat-Regular.ttf';
import './fonts/Montserrat/Montserrat-SemiBold.ttf';
import './fonts/Montserrat/Montserrat-Bold.ttf';
// import 'bootstrap/dist/css/bootstrap.min.css';


export const Context = createContext(null);

// ⬇️ Вынес инстансы СЮДА
const user = new UserStore();
const product = new ProductStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Context.Provider value={{ user, product }}>
      <App />
    </Context.Provider>
  </BrowserRouter>
);
